








































































import { computed, defineComponent, onMounted, PropType, ref, toRefs } from '@nuxtjs/composition-api';
import { SfButton, SfProductCardHorizontal, SfProperty, } from '@storefront-ui/vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { ProductInterface, useImage } from '~/composables';
import { useUser } from '~/modules/customer/composables/useUser';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import PictimeProductCard from '~/components/organisms/PictimeProductCard';
import HTMLContent from '../../../../../components/HTMLContent';
import SfLink from '@storefront-ui/vue/src/components/atoms/SfLink/SfLink.vue';
import truncateString from '../../../../../helpers/utils/truncateString';
import calculStock from '../../../../../helpers/utils/calculStock';
import calculFlap from '~/helpers/utils/calculFlap';

export default defineComponent({
  components: {
    CategoryProductPrice,
    SfProductCardHorizontal,
    SfButton,
    SfProperty,
    SkeletonLoader,
    PictimeProductCard,
    HTMLContent,
    SfLink,
  },
  props: {
    products: {
      type: Array as PropType<ProductInterface[]>,
      required: true,
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup(props) {
    const { isAuthenticated } = useUser();
    const isAuth = ref(false);

    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);

    const productsFormatted = computed(() => productsWithCommonProductCardProps.value.map((product) => {
      return {
        ...product
      };
    }));

    const { getMagentoImage, imageSizes } = useImage();

    const getTaxe = (isAuth) => {
      return !isAuth ? ' TTC' : ' HT'
    };

    onMounted(async () => {
      isAuth.value = await isAuthenticated();
    })

    return {
      productsFormatted,
      imageSizes,
      productGetters,
      getTaxe,
      getMagentoImage,
      truncateString,
      calculStock,
      calculFlap,
      isAuth
    };
  },
});
